<template lang="pug">
div
    v-dialog(v-model="isShowModal_" @close="isShowModal_=false" width="500")
        v-card
            v-card-title(class="elevation-1") 
                | Mantenedor {{nameModulo}}
                v-spacer
                v-btn(icon @click="isShowModal_=false")   
                    v-icon mdi-close
            v-container( fluid)
                v-row
                    .col-md-12.col-sm-12
                        label Nombre Tipo Lista
                        input.form-control.form-control-sm(v-model="parameter.Name", @keypress.enter="sendInfo()")  
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.IsMetaProd==2", @click="parameter.IsMetaProd=1,parameter.ActiveQuestions=2")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.IsMetaProd==1" ,@click="parameter.IsMetaProd=2,parameter.ActiveQuestions=1" )   ON
                v-row
                    v-col( cols="12" sm="12" md="12" v-show="parameter.IsMetaProd==2")
                        label Activar Preguntas
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveQuestions==2", @click="parameter.ActiveQuestions=1, parameter.ActiveItems=2")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveQuestions==1" ,@click="parameter.ActiveQuestions=2, parameter.ActiveItems=1" )   ON
                    v-col(cols="12" sm="12" md="12")
                        label Activar Items
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveItems==2", @click="parameter.ActiveItems=1, parameter.ActiveQuestions=2 ")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveItems==1" ,@click="parameter.ActiveItems=2, parameter.ActiveQuestions=1" )   ON
                v-row
                    .col-md-12.col-sm-12(v-show="parameter.ActiveQuestions==1")
                        label Activar Respuesta No Conformidades
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveAnswerNonconformities==2", @click="parameter.ActiveAnswerNonconformities=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveAnswerNonconformities==1" ,@click="parameter.ActiveAnswerNonconformities=2" )   ON 
                v-row
                    .col-md-12.col-sm-12(v-show="parameter.ActiveQuestions==1 && parameter.ActiveAnswerNonconformities==1")
                        label Activar Geolocacion
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveGeolocation==2 ||  parameter.ActiveGeolocation==null ||  parameter.ActiveGeolocation==''", @click="parameter.ActiveGeolocation=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveGeolocation==1" ,@click="parameter.ActiveGeolocation=2" )   ON
                v-row
                    .col-md-12.col-sm-12(v-show="parameter.ActiveQuestions==1 && parameter.ActiveAnswerNonconformities==1")
                        label Activar Responsables
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.ActiveResponsible==2 ||  parameter.ActiveResponsible==null ||  parameter.ActiveResponsible==''", @click="parameter.ActiveResponsible=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.ActiveResponsible==1" ,@click="parameter.ActiveResponsible=2" )   ON
            v-divider
            v-card-actions 
                v-spacer                    
                v-btn(color="primary" text @click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue"
import toolValidate from '../../../tools/validate.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.Name=='' || this.parameter.Name==null ){
                    this.$msgbox.show("Ingrese Nombre","Alerta")
                    return false
                } 
                else if(this.parameter.ActiveQuestions=='' || this.parameter.ActiveQuestions==null ){
                    this.$msgbox.show("Selecione  si activa preguntas","Alerta")
                    return false
                }
                else if(this.parameter.ActiveAnswerNonconformities=='' || this.parameter.ActiveAnswerNonconformities==null ){
                    this.$msgbox.show("Selecione si activa respuesta no conformidades","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>